import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventData: null,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setEventData: (state, action) => {
      state.eventData = action.payload;
    },
  },
});

export const { setEventData } = eventSlice.actions;
export default eventSlice.reducer;
